import { invokeApi, VENDOR_API_BASE_URL } from "../../../helper/axiosHelper";

export const PER_PAGE = 12;

export const documentUrl = (documentPath) =>
    `${VENDOR_API_BASE_URL}/${String(documentPath || "")
        .split("/")
        .map(encodeURIComponent)
        .join("/")}`;

export const fileKind = (fileName) => {
    const ext = String(fileName || "").split(".").pop().toLowerCase();
    if (ext === "pdf") return { cls: "pdf", label: "PDF", type: "PDF Document" };
    if (["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(ext))
        return {
            cls: "img",
            label: ext.toUpperCase(),
            type: `${ext.toUpperCase()} Image`,
        };
    if (["xls", "xlsx", "csv"].includes(ext))
        return { cls: "xls", label: ext.toUpperCase(), type: "Spreadsheet" };
    if (["doc", "docx"].includes(ext))
        return { cls: "doc", label: ext.toUpperCase(), type: "Word Document" };
    if (["ppt", "pptx"].includes(ext))
        return { cls: "ppt", label: ext.toUpperCase(), type: "Presentation" };
    if (["zip", "rar", "7z"].includes(ext))
        return { cls: "zip", label: ext.toUpperCase(), type: "Archive" };
    return {
        cls: "file",
        label: (ext || "FILE").toUpperCase(),
        type: ext ? `${ext.toUpperCase()} File` : "File",
    };
};

export const fileSize = (bytes) => {
    if (bytes === null || bytes === undefined || bytes === "") return "";
    const kb = Math.max(1, Math.round(Number(bytes) / 1024));
    return kb >= 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${kb} KB`;
};

export const uploadedOn = (createdDate) =>
    String(createdDate || "").split(" ")[0] || "—";

export const downloadName = (documentTitle, documentName) => {
    const ext = String(documentName || "").split(".").pop();
    const title = String(documentTitle || "document").replace(/[\\/:*?"<>|]+/g, "-");
    if (!ext || title.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) return title;
    return `${title}.${ext}`;
};

export const viewDocument = async (document) => {
    const response = await invokeApi(
        "post",
        "/vendorDocumentDownload",
        { documentId: document?.documentId },
        {},
        "vendor"
    );

    if (!response?.status) {
        return { status: false, message: response?.message || "Unable to open file" };
    }

    window.open(documentUrl(response.data?.documentPath), "_blank", "noopener");
    return { status: true };
};

export const downloadDocument = async (document) => {
    const response = await invokeApi(
        "post",
        "/vendorDocumentDownload",
        { documentId: document?.documentId },
        {},
        "vendor"
    );

    if (!response?.status) {
        return { status: false, message: response?.message || "Download failed" };
    }

    const url = documentUrl(response.data?.documentPath);
    const fileName = downloadName(
        response.data?.documentTitle,
        response.data?.documentName
    );

    try {
        const file = await fetch(url);
        if (!file.ok) throw new Error(String(file.status));
        const blob = await file.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = window.document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        window.document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
        window.open(url, "_blank", "noopener");
    }

    return { status: true };
};

export const ownerInitials = (name) =>
    String(name || "")
        .trim()
        .split(/\s+/)
        .map((word) => word[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
